var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmpty2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 987,
    height: 444,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empty_2_svg__clip0_10367_214775)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M908.38 295.164l-25.406-43.983a19.155 19.155 0 0013.564-10.923 19.146 19.146 0 00-.895-17.386l-27.864-48.234a19.16 19.16 0 0012.031-11.319 19.14 19.14 0 00-1.252-16.466l-22.114-38.268a19.145 19.145 0 00-16.583-9.566c-3.36 0-6.662.884-9.573 2.563a19.138 19.138 0 00-7.009 7.003l-22.114 38.268a19.14 19.14 0 003.48 23.488 19.16 19.16 0 007.299 4.297l-27.864 48.234a19.146 19.146 0 00-.895 17.386 19.157 19.157 0 0013.563 10.923l-25.406 43.983a19.132 19.132 0 000 19.134 19.135 19.135 0 007.007 7.004 19.16 19.16 0 009.572 2.564h103.861a19.158 19.158 0 0016.594-9.559 19.127 19.127 0 00.004-19.143z",
    fill: "#458845",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M941.622 371.095s-11.853-87.487 44.412-158.062c2.224-2.791-1.706-6.315-5.055-4.553-68.743 36.462-84.666 159.666-84.666 159.666l45.309 2.949z",
    fill: "#A9D063",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M816.563 300.709s34.34-99.776-16.554-194.543a3.159 3.159 0 01.724-3.878 3.158 3.158 0 013.945-.145c74.872 55.369 64.719 205.531 64.719 205.531l-52.834-6.965z",
    fill: "#5AB45C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M827.159 243.603s7.026-47.362-33.518-80.016c48.651 9.706 60.712 76.972 60.712 76.972l-27.194 3.044z",
    fill: "#A9D063",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M732.162 242.814s-8.991-65.486 28.269-116.788c-46.124 20.208-57.738 112.513-57.738 112.513l29.469 4.275z",
    fill: "#5AB45C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M942.392 195.894a25.27 25.27 0 01-6.647-9.339 56.09 56.09 0 00-22.301-26.329 56.142 56.142 0 00-65.528 4.555 56.092 56.092 0 00-18.439 29.162 25.092 25.092 0 01-6.596 11.499 41.036 41.036 0 00-5.672 50.633 41.067 41.067 0 0021.019 16.918 41.093 41.093 0 0026.986.227 12.637 12.637 0 0111.809 1.857 51.401 51.401 0 0070.901-8.078 51.34 51.34 0 0011.587-36.674 51.348 51.348 0 00-17.144-34.431h.025z",
    fill: "#00B487",
    stroke: "#001E3C",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M924.72 243.243a7.03 7.03 0 007.032-7.028 7.03 7.03 0 00-7.032-7.029 7.03 7.03 0 00-7.032 7.029 7.03 7.03 0 007.032 7.028z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M982.735 401.741l-20.326-35.193a15.333 15.333 0 0012.143-15.793 15.326 15.326 0 00-2.033-6.865l-22.298-38.597a15.33 15.33 0 009.645-9.062 15.31 15.31 0 00-1.02-13.191l-17.692-30.628a15.317 15.317 0 00-13.268-7.655 15.326 15.326 0 00-13.269 7.655l-17.691 30.628a15.311 15.311 0 002.775 18.815 15.323 15.323 0 005.849 3.438l-22.29 38.597a15.303 15.303 0 00-.729 13.907 15.317 15.317 0 0010.838 8.751l-20.333 35.193a15.307 15.307 0 005.61 20.915 15.33 15.33 0 007.659 2.052h83.162a15.32 15.32 0 0013.272-7.653 15.296 15.296 0 00-.004-15.314z",
    fill: "#458845",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M905.81 234.428a5.16 5.16 0 100-10.319 5.161 5.161 0 00-5.163 5.159c0 2.85 2.312 5.16 5.163 5.16z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M935.98 352.346s-5.952-40.106 28.382-67.765c-41.215 8.209-51.413 65.188-51.413 65.188l23.031 2.577z",
    fill: "#A9D063",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M946.802 309.095a11.64 11.64 0 00-5.579 2.905 3.093 3.093 0 01-4.219 4.253 3.103 3.103 0 01-1.54-2.702 3.093 3.093 0 01.433-1.551 11.702 11.702 0 00-5.579-2.905.748.748 0 00-.886.517.749.749 0 00-.011.373 10.45 10.45 0 008.485 8.481 1.37 1.37 0 011.302 0 10.43 10.43 0 008.485-8.481.74.74 0 00-.519-.879.744.744 0 00-.372-.011z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M946.802 316.37a11.697 11.697 0 00-5.579 2.905 3.09 3.09 0 01-1.107 4.253 3.1 3.1 0 01-4.246-1.144 3.09 3.09 0 01.027-3.109 11.759 11.759 0 00-5.579-2.905.748.748 0 00-.886.517.749.749 0 00-.011.373 10.45 10.45 0 008.485 8.481 1.37 1.37 0 011.302 0 10.436 10.436 0 005.585-2.899 10.415 10.415 0 002.9-5.582.74.74 0 00-.519-.879.744.744 0 00-.372-.011z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M946.803 323.645a11.704 11.704 0 00-5.579 2.904 3.094 3.094 0 01-4.219 4.254 3.103 3.103 0 01-1.54-2.702 3.094 3.094 0 01.433-1.552 11.757 11.757 0 00-5.579-2.904.756.756 0 00-.692.2.752.752 0 00-.205.69 10.446 10.446 0 008.485 8.481 1.37 1.37 0 011.302 0 10.436 10.436 0 005.585-2.899 10.415 10.415 0 002.9-5.582.74.74 0 00-.2-.69.748.748 0 00-.691-.2z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M946.803 330.919a11.702 11.702 0 00-5.579 2.905c.278.47.428 1.005.433 1.551a3.096 3.096 0 01-4.652 2.702 3.086 3.086 0 01-1.54-2.702 3.083 3.083 0 01.433-1.551 11.771 11.771 0 00-5.58-2.905.76.76 0 00-.695.203.76.76 0 00-.202.694 10.444 10.444 0 008.486 8.475 1.367 1.367 0 011.301 0 10.434 10.434 0 008.486-8.475.746.746 0 00-.891-.897z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M946.803 338.194a11.702 11.702 0 00-5.579 2.905c.278.47.428 1.005.433 1.551a3.103 3.103 0 01-1.541 2.702 3.09 3.09 0 01-3.111 0 3.081 3.081 0 01-1.134-1.144 3.083 3.083 0 01.027-3.109 11.762 11.762 0 00-5.58-2.905.76.76 0 00-.695.202.76.76 0 00-.202.695 10.447 10.447 0 008.486 8.474 1.38 1.38 0 011.301 0 10.432 10.432 0 008.486-8.474.737.737 0 00-.009-.373.737.737 0 00-.882-.524z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M946.803 345.469a11.702 11.702 0 00-5.579 2.905c.278.47.428 1.005.433 1.551a3.103 3.103 0 01-1.541 2.702 3.1 3.1 0 01-3.111 0 3.088 3.088 0 01-1.54-2.702 3.083 3.083 0 01.433-1.551 11.762 11.762 0 00-5.58-2.905.749.749 0 00-.885.523.764.764 0 00-.012.374 10.447 10.447 0 008.486 8.474 1.367 1.367 0 011.301 0 10.432 10.432 0 008.486-8.474.737.737 0 00-.009-.373.737.737 0 00-.882-.524z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M946.802 352.75a11.625 11.625 0 00-5.579 2.898 3.093 3.093 0 01-4.219 4.253 3.093 3.093 0 01-1.107-4.253 11.686 11.686 0 00-5.579-2.898.748.748 0 00-.886.517.749.749 0 00-.011.373 10.473 10.473 0 008.485 8.481 1.326 1.326 0 011.302 0 10.446 10.446 0 008.485-8.481.737.737 0 00-.891-.89z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M946.802 360.025a11.69 11.69 0 00-5.579 2.898 3.094 3.094 0 01.035 3.121 3.102 3.102 0 11-5.361-3.121 11.738 11.738 0 00-5.579-2.898.748.748 0 00-.886.517.748.748 0 00-.011.373 10.473 10.473 0 008.485 8.481 1.326 1.326 0 011.302 0 10.446 10.446 0 008.485-8.481.737.737 0 00-.891-.89z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M938.558 438.134V309.076",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M941.622 304.157c0 3.113-1.826 5.765-2.654 6.813a.504.504 0 01-.181.146.507.507 0 01-.453 0 .522.522 0 01-.181-.146c-.834-1.048-2.66-3.7-2.66-6.813 0-3.114 1.826-5.759 2.66-6.808a.524.524 0 01.634-.146.526.526 0 01.181.146c.803 1.049 2.654 3.701 2.654 6.808z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M940.977 367.495s1.358-24.906 27.933-35.426c-28.584-2.236-44.474 27.943-44.474 27.943l16.541 7.483z",
    fill: "#5AB45C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M957.879 344.894a11.755 11.755 0 00-5.586 2.905 3.087 3.087 0 01.032 3.112 3.094 3.094 0 01-5.383 0 3.088 3.088 0 01.031-3.112 11.743 11.743 0 00-5.585-2.905.749.749 0 00-.694.202.74.74 0 00-.197.695 10.447 10.447 0 008.486 8.475 1.367 1.367 0 011.301 0 10.447 10.447 0 008.486-8.475.74.74 0 00-.518-.886.748.748 0 00-.373-.011z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M957.879 352.169a11.747 11.747 0 00-5.586 2.905 3.084 3.084 0 01.032 3.112 3.099 3.099 0 01-5.383 0 3.09 3.09 0 01.031-3.112 11.734 11.734 0 00-5.585-2.905.749.749 0 00-.694.202.735.735 0 00-.188.322.737.737 0 00-.009.373 10.447 10.447 0 008.486 8.474 1.366 1.366 0 011.301 0 10.447 10.447 0 008.486-8.474.737.737 0 00-.009-.373.737.737 0 00-.882-.524z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M957.879 359.45a11.673 11.673 0 00-5.586 2.898 3.1 3.1 0 01.032 3.113 3.094 3.094 0 01-2.692 1.565 3.097 3.097 0 01-3.096-3.126 3.1 3.1 0 01.436-1.552 11.674 11.674 0 00-5.585-2.898.737.737 0 00-.695.196.733.733 0 00-.196.694 10.458 10.458 0 002.906 5.576 10.476 10.476 0 005.579 2.905 1.326 1.326 0 011.302 0 10.473 10.473 0 008.485-8.481.733.733 0 00-.196-.694.735.735 0 00-.694-.196z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M957.879 366.725a11.721 11.721 0 00-5.586 2.898 3.097 3.097 0 01.032 3.112 3.09 3.09 0 01-2.692 1.566 3.097 3.097 0 01-3.096-3.126 3.097 3.097 0 01.436-1.552 11.723 11.723 0 00-5.585-2.898.737.737 0 00-.891.89 10.458 10.458 0 002.906 5.576 10.476 10.476 0 005.579 2.905 1.327 1.327 0 011.302 0 10.473 10.473 0 008.485-8.481.737.737 0 00-.89-.89z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M957.879 374a11.721 11.721 0 00-5.586 2.898 3.097 3.097 0 01.032 3.112 3.09 3.09 0 01-2.692 1.566 3.097 3.097 0 01-3.096-3.126 3.097 3.097 0 01.436-1.552 11.723 11.723 0 00-5.585-2.898.737.737 0 00-.891.89 10.462 10.462 0 008.485 8.481 1.327 1.327 0 011.302 0 10.473 10.473 0 008.485-8.481.737.737 0 00-.89-.89z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M957.879 381.274a11.732 11.732 0 00-5.586 2.899 3.094 3.094 0 11-5.351 3.112 3.092 3.092 0 01.031-3.112 11.733 11.733 0 00-5.585-2.899.737.737 0 00-.695.196.737.737 0 00-.196.695 10.462 10.462 0 008.485 8.481 1.327 1.327 0 011.302 0 10.473 10.473 0 008.485-8.481.737.737 0 00-.89-.891z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M957.879 388.574a11.732 11.732 0 00-5.586 2.899 3.097 3.097 0 01.032 3.112 3.104 3.104 0 01-1.135 1.146 3.107 3.107 0 01-3.114 0 3.101 3.101 0 01-1.103-4.258 11.733 11.733 0 00-5.585-2.899.756.756 0 00-.691.2.745.745 0 00-.2.691 10.462 10.462 0 008.485 8.481 1.327 1.327 0 011.302 0 10.473 10.473 0 008.485-8.481.74.74 0 00-.52-.879.748.748 0 00-.37-.012z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M957.879 395.824a11.73 11.73 0 00-5.586 2.898 3.1 3.1 0 01.032 3.113 3.101 3.101 0 01-4.249 1.145 3.101 3.101 0 01-1.135-1.145 3.1 3.1 0 01.032-3.113 11.732 11.732 0 00-5.585-2.898.744.744 0 00-.891.89 10.458 10.458 0 002.906 5.576 10.476 10.476 0 005.579 2.905 1.37 1.37 0 011.302 0 10.473 10.473 0 008.485-8.481.74.74 0 00-.52-.879.736.736 0 00-.37-.011z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M949.634 440.805V303.367",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M952.697 339.949c0 3.107-1.826 5.76-2.66 6.814a.513.513 0 01-.808 0c-.834-1.054-2.661-3.707-2.661-6.814 0-3.106 1.827-5.765 2.661-6.813a.506.506 0 01.404-.198.515.515 0 01.404.198c.834 1.061 2.66 3.713 2.66 6.813z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M892.187 307.131c20.114 0 36.419-16.296 36.419-36.399s-16.305-36.399-36.419-36.399c-20.113 0-36.418 16.296-36.418 36.399s16.305 36.399 36.418 36.399zM20.907 411.611s4.726-19.507-8.214-35.49c16.915 6.795 18.064 35.73 18.064 35.73l-9.85-.24z",
    fill: "#5AB45C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M34.473 411.308s.41-14.474 16.46-20.347c-17.484-1.572-25.723 16.994-25.723 16.994l9.263 3.353z",
    fill: "#458845",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M948.028 434.212H128.755V399.77h64.219v-34.435h64.22v-34.441h64.22v-34.441h64.238v-34.442h64.22v-34.467h64.219v-34.416h64.207v-34.416h133.823c26.454 0 52.745 15.289 69.501 32.055l166.406 243.445z",
    fill: "#F2F2F2",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M246.877 442.358s-1.498-26.642 19.258-44.438c-23.744 4.825-32.192 42.392-32.192 42.392l12.934 2.046z",
    fill: "#5AB45C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M229.21 438.733s2.932-19.026-16.636-30.551c23.239 2.141 29.551 28.417 29.551 28.417l-12.915 2.134z",
    fill: "#A9D063",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M924.493 288.616l-2.824-4.938a51.802 51.802 0 00-3.343-5.539 275.13 275.13 0 00-80.344-77.32 275.305 275.305 0 00-104.448-39.101c-20.44 130.289-24.01 121.246-47.596 271.736 106.95-.069 143.773-4.566 148.007-19.993 15.107-55.122 43.64-122.294 73.292-123.38l-.214.113 4.498 7.471 9.035 3.789a3.156 3.156 0 003.037-.319 3.154 3.154 0 001.348-2.738l-.448-9.781z",
    fill: "#F34C54"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M924.493 288.616l-2.824-4.938a51.802 51.802 0 00-3.343-5.539 275.13 275.13 0 00-80.344-77.32 275.305 275.305 0 00-104.448-39.101c-20.44 130.289-24.01 121.246-47.596 271.736 106.95-.069 143.773-4.566 148.007-19.993 15.107-55.123 43.64-122.294 73.292-123.38l-.214.113 4.498 7.471 9.035 3.789a3.156 3.156 0 003.037-.319 3.154 3.154 0 001.348-2.738l-.448-9.781z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M901.083 263.779l-1.984-9.598-3.557-4.421a52.32 52.32 0 00-4.158-4.957 275.218 275.218 0 00-91.359-63.944 275.337 275.337 0 00-109.248-22.456c0 131.886-4.903 123.494-4.903 275.828h140.444c0-54.725 18.671-168.646 55.987-175.914l-.196.145 5.604 6.681 9.516 2.356a3.16 3.16 0 003.854-3.72z",
    fill: "#001E3C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M901.083 263.779l-1.984-9.598-3.557-4.421a52.32 52.32 0 00-4.158-4.957 275.218 275.218 0 00-91.359-63.944 275.337 275.337 0 00-109.248-22.456c0 131.886-4.903 123.494-4.903 275.828h140.444c0-54.725 18.671-168.646 55.987-175.914l-.196.145 5.604 6.681 9.516 2.356a3.16 3.16 0 003.854-3.72v0z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M690.777 434.212V174.171a260.07 260.07 0 0199.603 19.734 259.946 259.946 0 0184.441 56.364 259.809 259.809 0 0156.395 84.394 259.684 259.684 0 0119.744 99.549H690.777z",
    fill: "#F2F2F2",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M897.968 311.472l-31.512 18.184a6.205 6.205 0 00-2.273 8.48 6.212 6.212 0 008.484 2.272l31.512-18.184a6.206 6.206 0 002.274-8.48 6.214 6.214 0 00-8.485-2.272z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M863.464 371.524a18.624 18.624 0 005.446-6.422 41.192 41.192 0 0117.962-17.872 41.221 41.221 0 0147.656 7.43 41.17 41.17 0 0111.662 22.49 18.472 18.472 0 004.132 8.841 30.138 30.138 0 01.991 37.442 30.176 30.176 0 01-36.247 9.51 9.26 9.26 0 00-8.757.631 37.737 37.737 0 01-51.458-10.277 37.683 37.683 0 01-6.169-27.61 37.693 37.693 0 0114.782-24.125v-.038z",
    fill: "#458845",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M895.439 308.95l-31.512 18.184a6.206 6.206 0 00-2.274 8.48 6.214 6.214 0 008.485 2.272l31.512-18.184a6.206 6.206 0 002.273-8.48 6.212 6.212 0 00-8.484-2.272z",
    fill: "#88F4CB",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M915.931 390.412a9.25 9.25 0 00-4.063-.929 20.398 20.398 0 01-19.405-13.904 20.377 20.377 0 017.097-22.785 9.126 9.126 0 002.938-3.789 14.93 14.93 0 0116.237-8.959 14.92 14.92 0 0112.436 13.752 4.573 4.573 0 002.268 3.701 18.66 18.66 0 018.677 11.014 18.658 18.658 0 01-12.196 22.948 18.676 18.676 0 01-13.989-1.018v-.031z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M913.013 387.943a11.271 11.271 0 00-4.985-1.143 25.033 25.033 0 01-14.662-4.684 24.994 24.994 0 01-.433-40.329 11.256 11.256 0 003.602-4.685 18.317 18.317 0 0119.913-10.966c4.07.68 7.792 2.713 10.561 5.77a18.308 18.308 0 014.7 11.075 5.609 5.609 0 002.78 4.54 22.9 22.9 0 0110.539 13.514 22.886 22.886 0 01-1.794 17.04 22.92 22.92 0 01-30.227 9.861l.006.007z",
    fill: "#A9D063",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M900.711 370.034a3.265 3.265 0 10-3.267-3.265 3.266 3.266 0 003.267 3.265z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeWidth: 0.63,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M903.326 343.884a5.88 5.88 0 013.159 1.85.264.264 0 01.068.218.26.26 0 01-.131.186 5.058 5.058 0 01-6.748-1.073.258.258 0 01-.024-.326.26.26 0 01.087-.078 5.846 5.846 0 013.589-.777z",
    fill: "#458845",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M924.442 378.527a4.761 4.761 0 01-1.895 2.318.218.218 0 01-.263-.024.205.205 0 01-.053-.077 4.1 4.1 0 011.706-5.298.2.2 0 01.183-.028c.03.01.058.026.081.049a.206.206 0 01.052.08c.38.947.447 1.992.189 2.98z",
    fill: "#00B487",
    stroke: "#001E3C",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M906.915 392.995h-24.736a3.859 3.859 0 01-3.918-3.644 3.745 3.745 0 013.76-3.877h9.389a4.462 4.462 0 004.517-4.206 4.31 4.31 0 00-.289-1.7 4.326 4.326 0 00-4.045-2.771h-29.854a1.149 1.149 0 01-1.156-.928 1.107 1.107 0 01.631-1.192c.146-.068.307-.103.468-.103h7.753a4.232 4.232 0 004.29-3.991 4.117 4.117 0 00-4.113-4.243h-2.559a6.832 6.832 0 01-6.824-6.82v-.442a6.832 6.832 0 016.824-6.821h2.837a6.822 6.822 0 004.824-1.993 6.812 6.812 0 002-4.82v-1.598a6.372 6.372 0 00-3.027-5.481 5.486 5.486 0 01-2.578-4.831 4.883 4.883 0 00-1.441-3.461 4.902 4.902 0 00-3.468-1.427h-1.839a4.2 4.2 0 00-2.964 1.229 4.177 4.177 0 00-1.225 2.964 4.189 4.189 0 01-4.195 4.187h-18.924a4.191 4.191 0 01-4.189-4.187 4.186 4.186 0 00-4.189-4.193h-23.814v107.113h68.46a2.684 2.684 0 002.634-2.721v-4.364c0-1.743 1.7-1.838 2.673-1.838h8.846c2.754 0 4.991-1.414 4.991-4.502s-2.799-4.787-5.055-4.787h-4.663a3.595 3.595 0 01-3.423-2.288 3.59 3.59 0 01-.241-1.431 4.338 4.338 0 014.34-4.339h23.492a6.823 6.823 0 006.824-6.82v-2.854a6.825 6.825 0 00-6.824-6.82z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M905.146 391.22H880.41a3.873 3.873 0 01-3.924-3.65 3.787 3.787 0 013.791-3.877h9.383a4.465 4.465 0 004.524-4.2 4.336 4.336 0 00-1.226-3.151 4.348 4.348 0 00-3.115-1.32h-29.867a1.149 1.149 0 01-1.156-.928 1.107 1.107 0 01.625-1.196 1.11 1.11 0 01.468-.105h7.759a4.232 4.232 0 004.29-3.991 4.12 4.12 0 00-2.513-3.918 4.105 4.105 0 00-1.606-.325h-2.559a6.819 6.819 0 01-6.818-6.814v-.442a6.814 6.814 0 016.818-6.82h2.843a6.832 6.832 0 006.824-6.82v-1.598a6.38 6.38 0 00-3.027-5.481 5.484 5.484 0 01-1.936-2.067 5.481 5.481 0 01-.642-2.758 4.882 4.882 0 00-1.441-3.461 4.905 4.905 0 00-3.468-1.427h-1.845a4.198 4.198 0 00-2.962 1.227 4.174 4.174 0 00-1.227 2.96 4.186 4.186 0 01-4.189 4.187h-18.949a4.191 4.191 0 01-4.189-4.187 4.174 4.174 0 00-1.227-2.96 4.183 4.183 0 00-2.962-1.227h-23.814v107.114h68.459a2.692 2.692 0 002.642-2.729v-4.357c0-1.736 1.693-1.837 2.672-1.837h8.846c2.761 0 4.991-1.415 4.991-4.509 0-3.095-2.799-4.781-5.054-4.781h-4.67a3.593 3.593 0 01-2.631-1.071 3.611 3.611 0 01-.787-1.218 3.601 3.601 0 01-.24-1.43 4.34 4.34 0 011.267-3.067 4.34 4.34 0 013.068-1.271h23.498a6.825 6.825 0 006.817-6.82v-2.849a6.805 6.805 0 00-1.988-4.821 6.812 6.812 0 00-4.817-2.005z",
    fill: "#5AB45C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M840.509 350.483a2.268 2.268 0 10.002-4.536 2.268 2.268 0 00-.002 4.536zM870.168 384.482a3.228 3.228 0 003.229-3.227 3.228 3.228 0 00-6.458 0 3.228 3.228 0 003.229 3.227zM853.468 408.687a2.451 2.451 0 10.002-4.902 2.451 2.451 0 00-.002 4.902zM860.046 412.205a1.643 1.643 0 100-3.285 1.643 1.643 0 000 3.285zM863.324 338.213a1.642 1.642 0 10.002-3.284 1.642 1.642 0 00-.002 3.284z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M848.786 434.212a157.85 157.85 0 00-11.739-60.74 157.903 157.903 0 00-34.185-51.573 158.008 158.008 0 00-51.383-34.492 158.088 158.088 0 00-121.397 0 158.008 158.008 0 00-51.383 34.492 157.888 157.888 0 00-45.924 112.313h316.011z",
    fill: "#fff",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M537.002 266.994a57.106 57.106 0 0152.758 35.232 57.049 57.049 0 014.347 21.842v110.144H479.896V324.068a57.062 57.062 0 0116.726-40.358 57.122 57.122 0 0140.38-16.716z",
    fill: "#fff",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M539.308 359.469h-22.954v81.891h22.954v-81.891z",
    fill: "#8E623D",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M564.727 406.944l-13.68-23.681a10.314 10.314 0 007.299-5.888 10.321 10.321 0 00-.481-9.362l-15.006-25.973a10.32 10.32 0 006.49-6.101c.557-1.437.785-2.98.666-4.516a10.296 10.296 0 00-1.35-4.362l-11.903-20.58a10.315 10.315 0 00-17.856 0l-11.91 20.611a10.315 10.315 0 005.807 14.979l-15.006 25.974a10.3 10.3 0 00-.48 9.364 10.325 10.325 0 007.303 5.886l-13.679 23.681a10.302 10.302 0 003.773 14.077 10.318 10.318 0 005.155 1.382h55.93a10.308 10.308 0 0010.327-10.33 10.31 10.31 0 00-1.399-5.161z",
    fill: "#458845",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M499.597 340.183a57.054 57.054 0 0116.726-40.357 57.118 57.118 0 0140.379-16.717 56.886 56.886 0 0125.394 5.943 57.018 57.018 0 00-45.094-22.058 57.126 57.126 0 00-40.38 16.72 57.062 57.062 0 00-16.726 40.36v110.46h19.701v-94.351z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M453.024 158.687h125.274v34.441H449.865v-31.284a3.16 3.16 0 013.159-3.157z",
    fill: "#DDF8EF",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M388.793 193.128h125.28v34.442H385.634v-31.284a3.158 3.158 0 013.159-3.158z",
    fill: "#DDF8EF",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M324.573 227.57h125.293v34.441H321.414v-31.284a3.157 3.157 0 013.159-3.157zM385.634 262.011h-128.44v34.442h128.44v-34.442z",
    fill: "#DDF8EF",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M196.134 296.446h125.28V330.9H192.975v-31.296a3.16 3.16 0 013.159-3.158z",
    fill: "#DDF8EF",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M131.914 330.9h125.28v34.442H128.755v-31.284a3.158 3.158 0 013.159-3.158z",
    fill: "#DDF8EF",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M67.694 365.329h125.28v34.442H64.535v-31.284a3.156 3.156 0 013.16-3.158z",
    fill: "#DDF8EF",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M3.475 399.771h125.28v34.441H.315v-31.284a3.158 3.158 0 013.16-3.157z",
    fill: "#DDF8EF",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M144.551 431.054v-12.339a3.156 3.156 0 013.16-3.157h57.901a3.158 3.158 0 003.159-3.158v-28.12c0-.837.333-1.64.925-2.233a3.16 3.16 0 012.234-.924h57.901a3.16 3.16 0 003.159-3.158v-28.126a3.16 3.16 0 013.16-3.158h57.901a3.158 3.158 0 003.159-3.157v-28.127a3.157 3.157 0 013.159-3.157h57.92a3.16 3.16 0 003.16-3.158v-28.126a3.16 3.16 0 013.159-3.158h57.901a3.16 3.16 0 002.234-.924 3.161 3.161 0 00.925-2.233v-28.152a3.157 3.157 0 013.159-3.157h57.901a3.16 3.16 0 003.16-3.158v-28.101a3.16 3.16 0 013.159-3.157h57.908a3.16 3.16 0 003.159-3.158v-28.101a3.158 3.158 0 013.159-3.158h111.708a3.16 3.16 0 002.234-.924 3.161 3.161 0 00.925-2.233v-9.472a3.158 3.158 0 00-3.159-3.158H581.458a3.16 3.16 0 00-3.159 3.158v28.126a3.158 3.158 0 01-3.159 3.158h-57.908a3.16 3.16 0 00-2.234.924 3.161 3.161 0 00-.925 2.233v28.076a3.16 3.16 0 01-3.159 3.157h-57.902a3.16 3.16 0 00-3.159 3.158v28.126a3.16 3.16 0 01-3.159 3.158h-57.882a3.16 3.16 0 00-3.159 3.157v28.127a3.157 3.157 0 01-3.159 3.157h-57.902a3.158 3.158 0 00-3.159 3.158v28.126a3.158 3.158 0 01-3.159 3.158h-57.901a3.156 3.156 0 00-3.159 3.157v28.127a3.16 3.16 0 01-3.159 3.157h-57.902a3.162 3.162 0 00-3.159 3.158v28.12a3.157 3.157 0 01-3.159 3.157h-57.901a3.16 3.16 0 00-3.16 3.158v28.126a3.16 3.16 0 003.16 3.158h9.477a3.156 3.156 0 003.14-3.133z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M936.896 434.212h-48.803a6.212 6.212 0 016.204-6.208h36.394a6.208 6.208 0 016.205 6.208z",
    fill: "#88F4CB",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M946.246 387.513c-2.375-.581-6.811.878-9.149-3.208-3.538-6.176-2.641-13.551-6.609-17.839-2.23-2.406-4.877-1.036-4.252 1.496.626 2.533 4.985 14.727 1.896 16.861-3.09 2.135-7.816 2.28-9.693 3-1.876.72.512 1.616 1.087 1.976.575.36 6.363-.846 7.405-.543 1.043.303 1.156 1.219 2.104 1.49.948.272 2.641-.277 3.418-.631.777-.354 1.807.631 3.159.631 1.353 0 13.345 1.529 14.747.632 1.157-.739-1.712-3.277-4.113-3.865z",
    fill: "#458845",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M929.334 413.321c2.943-13.019-3.314-25.524-13.974-27.931-10.661-2.407-21.689 6.195-24.631 19.214-2.943 13.019 3.313 25.525 13.974 27.932 10.66 2.407 21.688-6.196 24.631-19.215z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M931.666 412.821c1.639-13.247-4.806-24.946-14.396-26.131-9.589-1.185-18.691 8.592-20.331 21.838-1.639 13.247 4.806 24.946 14.396 26.131 9.589 1.185 18.692-8.592 20.331-21.838z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M939.468 413.561c2.091-13.328-3.618-25.292-12.75-26.723-9.132-1.43-18.23 8.214-20.32 21.541-2.091 13.327 3.617 25.291 12.75 26.722 9.132 1.431 18.23-8.213 20.32-21.54z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M961.762 432.707c10.661-2.407 16.917-14.912 13.974-27.931-2.942-13.019-13.97-21.622-24.63-19.215-10.661 2.407-16.918 14.913-13.975 27.932 2.943 13.019 13.971 21.621 24.631 19.214z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M955.094 434.846c9.589-1.185 16.034-12.884 14.395-26.131-1.639-13.246-10.742-23.023-20.331-21.838-9.589 1.186-16.034 12.885-14.395 26.131 1.639 13.246 10.741 23.023 20.331 21.838z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M947.213 435.398c9.132-1.43 14.841-13.394 12.75-26.722-2.09-13.327-11.188-22.971-20.32-21.54-9.133 1.431-14.841 13.395-12.75 26.722 2.09 13.327 11.188 22.971 20.32 21.54z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M933.971 438.67c8.776 0 15.89-11.942 15.89-26.674s-7.114-26.674-15.89-26.674-15.891 11.942-15.891 26.674 7.115 26.674 15.891 26.674z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M808.515 225.982l-18.194 31.495a6.206 6.206 0 002.274 8.48 6.213 6.213 0 008.484-2.272l18.194-31.495a6.206 6.206 0 00-2.274-8.48 6.213 6.213 0 00-8.484 2.272z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M805.353 223.456l-18.194 31.495a6.206 6.206 0 002.274 8.48 6.213 6.213 0 008.484-2.272l18.193-31.495a6.206 6.206 0 00-2.273-8.48 6.212 6.212 0 00-8.484 2.272z",
    fill: "#88F4CB",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M684.566 188.222v48.782h12.422v-48.782h-12.422z",
    fill: "#6EC6DA",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M579.361 224.084a6.212 6.212 0 00-8.484-2.272 6.206 6.206 0 00-2.274 8.48l18.194 31.495a6.213 6.213 0 008.484 2.272 6.205 6.205 0 002.274-8.479l-18.194-31.496z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M576.202 223.449a6.213 6.213 0 00-8.484-2.272 6.206 6.206 0 00-2.274 8.48l18.194 31.495a6.213 6.213 0 008.484 2.272 6.205 6.205 0 002.273-8.48l-18.193-31.495z",
    fill: "#88F4CB",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M313.838 141.712c0 1.428-1.264 4.023-1.264 5.305.095 3.726 1.485 5.544 1.1 6.233a2.654 2.654 0 01-1.441.972s.398 3.638-1.086 5.122c-1.485 1.484-4.07 1.042-5.156 1.086-.152 1.894-.891 12.282-3.419 12.781-2.527.499-14.026-6.043-14.026-6.043v-7.925l6.742-3.467 2.179-14.064h16.371zM250.073 173.009l-.467.265a12.931 12.931 0 00-5.756 15.409l5.276 15.288 12.542-13.773-11.595-17.189zM310.306 275.651h-19.941v11.354h19.941v-11.354z",
    fill: "#FFCBBD",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M275.005 161.927l-24.932 11.076 6.843 18.143 18.089-29.219z",
    fill: "#88F4CB",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M238.567 292.14v-19.93h-11.36v19.93h11.36z",
    fill: "#FFCBBD",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M243.654 218.748v40.725l-12.447 8.367v29.68l32.584-21.9a12.949 12.949 0 005.718-10.736v-43.023l-25.855-3.113z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M280.995 221.861l25.906 18.395a12.933 12.933 0 015.446 10.546v32.352h-25.905v-25.008l-33.361-23.687a12.946 12.946 0 01-5.446-10.546v-5.19l33.36 3.138z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M288.932 224.627h-23.448c-10.741 0-18.449-5.481-23.479-3.543-9.168 3.543-8.89-.347-14.62-1.193-5.731-.846-1.574-8.052 2.249-6.675 5.51 1.977 6.647-10.42 15.588-11.316 14.961-1.51 4.359-9.473 19.384-32.667 5.958-9.188 19.916-12.864 25.135-10.502.62.254 1.192.615 1.686 1.067-1.832 7.073 12.745 12.63 13.345 9.53.183-.929.057.631 1.371 2.525 6.217 8.93-7.513 30.135-14.848 42.645-3.001 5.102 2.742 10.129-2.363 10.129z",
    fill: "#88F4CB",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M283.194 195.907l-4.1-12.434M248.576 256.151l-4.726 3.183",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M301.423 186.952l3.683 8.879s20.996-10.236 24.301-11.727c11.594-5.216 14.949 9.1 10.33 11.999-3.475 2.159-6.615-4.85-9.812-2.526-3.197 2.324-14.469 19.671-26.607 19.671-15.846 0-20.124-17.31-20.124-17.31l18.229-8.986z",
    fill: "#FFCBBD",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M291.294 254.793l-4.732 3.177",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M288.931 285.856h21.893c2.81 0 5.505 1.116 7.493 3.102a10.588 10.588 0 013.103 7.488h-24.73a7.774 7.774 0 01-5.491-2.273 7.757 7.757 0 01-2.274-5.488v-2.829h.006zM228.351 270.808v21.881a10.598 10.598 0 01-10.596 10.59v-24.71a7.76 7.76 0 017.765-7.761h2.831z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M288.255 158.22c2.925.922 9.534 5.171 12.7-2.836 1.485-3.789-2.559-5.096.632-7.799 2.287-1.926 3.841 1.712 6.394-1.218 3.102-3.562 7.519-.247 6.836-5.147-.524-3.789-25.425-13.173-22.992 13.173.423 4.464-6.634 2.848-3.57 3.827z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M301.422 186.952l-1.674-5.071",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M296.691 296.453h24.723a10.953 10.953 0 00-.189-1.996h-29.697a7.736 7.736 0 005.163 1.996zM217.755 278.537v24.704c.67-.002 1.338-.065 1.997-.189v-29.68a7.72 7.72 0 00-1.997 5.165z",
    fill: "#fff",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M717.175 434.61l85.235-69.174a1.265 1.265 0 00-.495-2.199 1.262 1.262 0 00-.902.109l-97.302 52.673-10.59 18.193 24.054.398z",
    fill: "#88F4CB",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M716.664 434.212c0-6.867-2.73-13.452-7.588-18.308a25.913 25.913 0 00-36.635 0 25.885 25.885 0 00-7.587 18.308h51.81z",
    fill: "#6EC6DA",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M629.016 263.369l20.332 13.71-9.667 55.602-10.665-69.312zM751.03 265.844l-20.333 13.716 9.661 55.597 10.672-69.313zM708.197 262.592L693.09 438.133h-4.632l-15.101-175.541h34.84z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M640.692 258.487C645.564 77.679 690.778.335 690.778.335s45.214 77.345 50.085 258.152H640.692z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M710.491 267.871h-39.426l-3.002-15.667h45.429l-3.001 15.667z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M690.777 142.767c13.7 0 24.806-11.1 24.806-24.792 0-13.693-11.106-24.792-24.806-24.792-13.699 0-24.805 11.099-24.805 24.792 0 13.692 11.106 24.792 24.805 24.792z",
    fill: "#F2F2F2",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M690.777 137.721c10.912 0 19.757-8.84 19.757-19.746 0-10.906-8.845-19.747-19.757-19.747s-19.757 8.841-19.757 19.747 8.845 19.746 19.757 19.746z",
    fill: "#6EC6DA",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M690.777.316S679.619 19.412 667.791 60.8h45.972C701.935 19.412 690.777.316 690.777.316zM728.314 284.77c15.013-5.57 24.73-18.187 24.73-18.187l-17.868-89.671c1.144 29.566 1.017 71.749-6.862 107.858zM653.24 284.77c-15.013-5.57-24.73-18.187-24.73-18.187l17.868-89.671c-1.156 29.566-1.043 71.749 6.862 107.858z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M758.611 351.354v54.618M742.02 366.207v54.617M751.212 382.215v18.793",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M837.679 342.034a11.7 11.7 0 00-5.579 2.904 3.093 3.093 0 01-1.108 4.254 3.1 3.1 0 01-4.246-1.144 3.095 3.095 0 01.027-3.11 11.73 11.73 0 00-5.579-2.904.74.74 0 00-.879.519.752.752 0 00-.012.371 10.427 10.427 0 008.479 8.481.734.734 0 00.632-.164.748.748 0 00.632.164 10.43 10.43 0 008.479-8.481.744.744 0 00-.846-.89z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M837.678 349.308a11.706 11.706 0 00-5.579 2.905 3.093 3.093 0 01-4.219 4.253 3.093 3.093 0 01-1.107-4.253 11.741 11.741 0 00-5.579-2.905.748.748 0 00-.883.524.748.748 0 00-.008.373 10.433 10.433 0 008.479 8.475.73.73 0 00.632-.165.743.743 0 00.632.165 10.434 10.434 0 008.479-8.475.752.752 0 00-.186-.672.737.737 0 00-.661-.225z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M837.678 356.583a11.706 11.706 0 00-5.579 2.905 3.093 3.093 0 01-4.219 4.253 3.096 3.096 0 01-1.107-4.253 11.741 11.741 0 00-5.579-2.905.748.748 0 00-.883.524.748.748 0 00-.008.373 10.436 10.436 0 008.479 8.474.728.728 0 00.632-.164.743.743 0 00.632.164 10.433 10.433 0 008.479-8.474.752.752 0 00-.488-.867.755.755 0 00-.359-.03z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M837.679 363.864a11.63 11.63 0 00-5.579 2.899 3.1 3.1 0 01.433 1.551 3.103 3.103 0 01-1.541 2.702 3.1 3.1 0 01-4.246-1.144 3.092 3.092 0 01.028-3.109 11.655 11.655 0 00-5.58-2.899.737.737 0 00-.883.518.744.744 0 00-.008.372 10.434 10.434 0 008.48 8.475.73.73 0 00.631-.164.753.753 0 00.632.164 10.433 10.433 0 008.479-8.475.735.735 0 00-.488-.863.737.737 0 00-.358-.027z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M837.679 371.139a11.681 11.681 0 00-5.579 2.898 3.105 3.105 0 01.035 3.121 3.102 3.102 0 11-5.361-3.121 11.72 11.72 0 00-5.58-2.898.748.748 0 00-.373.007.749.749 0 00-.51.511.744.744 0 00-.008.372 10.447 10.447 0 008.48 8.481.72.72 0 00.631-.17.735.735 0 00.632.17 10.438 10.438 0 008.479-8.481.735.735 0 00-.488-.863.737.737 0 00-.358-.027z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M837.679 378.414c-2.09.438-4.02 1.44-5.579 2.898a3.102 3.102 0 11-5.326 0 11.71 11.71 0 00-5.58-2.898.737.737 0 00-.891.89 10.447 10.447 0 008.48 8.481.707.707 0 00.631-.171.737.737 0 00.632.171 10.447 10.447 0 008.479-8.481.74.74 0 00-.846-.89z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M837.679 385.688a11.683 11.683 0 00-5.579 2.899 3.098 3.098 0 01-1.102 4.269 3.104 3.104 0 01-4.26-1.149 3.098 3.098 0 01.036-3.12 11.712 11.712 0 00-5.58-2.899.737.737 0 00-.883.518.748.748 0 00-.008.373 10.444 10.444 0 008.48 8.481.707.707 0 00.631-.171.75.75 0 00.296.16c.11.029.225.033.336.011a10.46 10.46 0 005.579-2.904 10.435 10.435 0 002.9-5.577.74.74 0 00-.846-.891z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M837.679 392.995a11.681 11.681 0 00-5.579 2.898 3.102 3.102 0 11-5.326 0 11.71 11.71 0 00-5.58-2.898.737.737 0 00-.891.89 10.447 10.447 0 008.48 8.481.707.707 0 00.631-.171.737.737 0 00.632.171 10.438 10.438 0 008.479-8.481.74.74 0 00-.846-.89z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M829.434 441.367v-99.353",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M832.498 337.102c0 3.107-1.82 5.759-2.654 6.813a.528.528 0 01-.407.195.533.533 0 01-.408-.195c-.834-1.054-2.66-3.706-2.66-6.813 0-3.107 1.826-5.766 2.66-6.814a.522.522 0 01.634-.146.504.504 0 01.181.146c.834 1.048 2.654 3.7 2.654 6.814z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M520.397 158.687h24.212l12.289-80.692-36.501 80.692z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M556.899 77.995l-12.29 80.692h48.797l-36.507-80.692z",
    fill: "#6EC6DA",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M516.297 158.687c11.606 0 21.015-9.404 21.015-21.003 0-11.6-9.409-21.004-21.015-21.004s-21.015 9.404-21.015 21.004c0 11.599 9.409 21.003 21.015 21.003z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M510.376 134.444a5.919 5.919 0 005.921-5.917 5.919 5.919 0 00-5.921-5.917 5.919 5.919 0 00-5.92 5.917 5.919 5.919 0 005.92 5.917zM685.874 116.68c4.714 0 8.536-3.819 8.536-8.531 0-4.712-3.822-8.532-8.536-8.532-4.714 0-8.536 3.82-8.536 8.532s3.822 8.531 8.536 8.531z",
    fill: "#fff",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M171.214 330.888c7.831 0 14.179-6.345 14.179-14.171s-6.348-14.171-14.179-14.171c-7.83 0-14.178 6.345-14.178 14.171s6.348 14.171 14.178 14.171z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M167.221 314.532a3.992 3.992 0 003.993-3.991 3.992 3.992 0 00-3.993-3.991 3.992 3.992 0 100 7.982z",
    fill: "#fff",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M700.742 434.212a9.956 9.956 0 00-2.919-7.042 9.969 9.969 0 00-14.091 0 9.956 9.956 0 00-2.919 7.042h19.929z",
    fill: "#F2F2F2",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M966.756 434.212H.316v9.472h966.44v-9.472zM901.286 296.377a14.583 14.583 0 00-5.213 4.067 32.37 32.37 0 01-36.543 9.932 32.353 32.353 0 01-20.954-31.529 14.51 14.51 0 00-1.763-7.439 23.667 23.667 0 015.227-28.936 23.697 23.697 0 0129.379-1.534 7.253 7.253 0 006.83.922 29.64 29.64 0 0122.236.372 29.612 29.612 0 0115.709 15.732 29.59 29.59 0 01.329 22.224 29.615 29.615 0 01-15.237 16.189z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M899.744 290.984a14.592 14.592 0 00-5.213 4.067 32.36 32.36 0 01-16.665 10.876 32.382 32.382 0 01-19.883-.931 32.353 32.353 0 01-15.575-12.387 32.317 32.317 0 01-5.373-19.155 14.531 14.531 0 00-1.769-7.433 23.659 23.659 0 01-2.433-15.38 23.671 23.671 0 017.652-13.564 23.7 23.7 0 0129.386-1.532 7.267 7.267 0 006.83.922 29.642 29.642 0 0122.169.453 29.619 29.619 0 0115.646 15.704 29.595 29.595 0 01.358 22.159 29.618 29.618 0 01-15.13 16.201z",
    fill: "#5AB45C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M856.615 269.823a7.814 7.814 0 007.815-7.812 7.813 7.813 0 00-7.815-7.811 7.813 7.813 0 00-7.816 7.811 7.814 7.814 0 007.816 7.812zM880.05 280.817a6.304 6.304 0 006.305-6.302 6.304 6.304 0 00-6.305-6.303 6.304 6.304 0 00-6.306 6.303 6.304 6.304 0 006.306 6.302z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M882.646 248.447c-.846 2.627-3.115 4.382-4.107 5.052a.454.454 0 01-.397.056.474.474 0 01-.178-.106.449.449 0 01-.113-.171c-.424-1.118-1.264-3.865-.398-6.498.865-2.634 3.115-4.383 4.107-5.052a.456.456 0 01.575.049.46.46 0 01.113.172c.417 1.118 1.245 3.864.398 6.498z",
    fill: "#00B487",
    stroke: "#001E3C",
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M865.846 293.794a7.706 7.706 0 014.625-1.339.336.336 0 01.331.271.34.34 0 01-.002.152 6.633 6.633 0 01-7.127 5.463.356.356 0 01-.264-.135.35.35 0 01-.065-.288 7.692 7.692 0 012.502-4.124z",
    fill: "#5AB45C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M870.168 208.499a6.392 6.392 0 006.394-6.391 6.392 6.392 0 00-6.394-6.39 6.392 6.392 0 00-6.395 6.39 6.393 6.393 0 006.395 6.391z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M626.116 425.63c0-18.888-18.898-17.126-18.898-29.983V379.5s18.898 6.858 18.898 20.384v25.746z",
    fill: "#458845",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M626.115 427.133c0-14.935 10.508-15.156 10.508-25.361v-15.724s-10.508 6.852-10.508 17.556v23.529z",
    fill: "#A9D063",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M626.115 438.19v-46.225c0-16.336 14.652-20.283 14.652-20.283",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M640.768 380.712c4.99 0 9.035-4.043 9.035-9.03 0-4.987-4.045-9.03-9.035-9.03s-9.036 4.043-9.036 9.03c0 4.987 4.046 9.03 9.036 9.03z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M640.768 375.629a3.948 3.948 0 100-7.894 3.948 3.948 0 100 7.894z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M827.164 322.457a11.704 11.704 0 00-5.585 2.905 3.097 3.097 0 01.032 3.112 3.09 3.09 0 01-2.692 1.566 3.097 3.097 0 01-3.096-3.126 3.097 3.097 0 01.436-1.552 11.704 11.704 0 00-5.585-2.905.752.752 0 00-.88.52.74.74 0 00-.011.371 10.446 10.446 0 008.485 8.481 1.371 1.371 0 011.302 0 10.436 10.436 0 005.585-2.899 10.419 10.419 0 002.9-5.582.74.74 0 00-.52-.879.752.752 0 00-.371-.012z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M827.164 329.732a11.752 11.752 0 00-5.585 2.905 3.097 3.097 0 01.032 3.112 3.096 3.096 0 11-5.352-3.112 11.752 11.752 0 00-5.585-2.905.74.74 0 00-.691.2.745.745 0 00-.2.69 10.45 10.45 0 008.485 8.481 1.382 1.382 0 011.302 0 10.43 10.43 0 008.485-8.481.736.736 0 00-.2-.69.745.745 0 00-.691-.2z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M827.164 337.007a11.743 11.743 0 00-5.585 2.905 3.094 3.094 0 11-5.351 3.112 3.092 3.092 0 01.031-3.112 11.743 11.743 0 00-5.585-2.905.74.74 0 00-.691.2.748.748 0 00-.2.69 10.45 10.45 0 008.485 8.481 1.382 1.382 0 011.302 0 10.43 10.43 0 008.485-8.481.74.74 0 00-.52-.879.74.74 0 00-.371-.011z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M827.165 344.282a11.741 11.741 0 00-5.585 2.904 3.095 3.095 0 11-5.32 0 11.75 11.75 0 00-5.586-2.904.752.752 0 00-.891.896 10.447 10.447 0 008.486 8.475 1.367 1.367 0 011.301 0 10.423 10.423 0 008.486-8.475.748.748 0 00-.197-.695.745.745 0 00-.694-.201z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M827.165 351.556a11.752 11.752 0 00-5.585 2.905 3.09 3.09 0 01.031 3.112 3.094 3.094 0 01-5.383 0 3.088 3.088 0 01.032-3.112 11.76 11.76 0 00-5.586-2.905.752.752 0 00-.891.897 10.444 10.444 0 008.486 8.475 1.368 1.368 0 011.301 0 10.44 10.44 0 005.584-2.897 10.417 10.417 0 002.902-5.578.748.748 0 00-.197-.695.747.747 0 00-.694-.202z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M827.165 358.831a11.743 11.743 0 00-5.585 2.905 3.092 3.092 0 01-1.103 4.258 3.096 3.096 0 01-4.217-4.258 11.75 11.75 0 00-5.586-2.905.752.752 0 00-.891.897 10.447 10.447 0 008.486 8.474 1.367 1.367 0 011.301 0 10.432 10.432 0 008.486-8.474.748.748 0 00-.197-.695.737.737 0 00-.694-.202z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M827.164 366.112a11.733 11.733 0 00-5.585 2.899 3.093 3.093 0 01-4.217 4.257 3.091 3.091 0 01-1.103-4.257 11.733 11.733 0 00-5.585-2.899.752.752 0 00-.691.2.745.745 0 00-.2.69 10.461 10.461 0 008.485 8.481 1.337 1.337 0 011.302 0 10.445 10.445 0 008.485-8.481.733.733 0 00-.196-.694.735.735 0 00-.695-.196z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M827.164 373.418a11.733 11.733 0 00-5.585 2.899 3.097 3.097 0 01.032 3.112 3.09 3.09 0 01-2.692 1.566 3.097 3.097 0 01-3.096-3.126 3.097 3.097 0 01.436-1.552 11.733 11.733 0 00-5.585-2.899.752.752 0 00-.88.52.74.74 0 00-.011.371 10.462 10.462 0 008.485 8.481 1.327 1.327 0 011.302 0 10.456 10.456 0 005.582-2.902 10.439 10.439 0 002.903-5.579.737.737 0 00-.891-.891z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M818.92 441.367V322.438",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M821.984 317.519c0 3.113-1.826 5.766-2.66 6.814a.508.508 0 01-.629.146.52.52 0 01-.18-.146c-.834-1.048-2.66-3.701-2.66-6.814s1.826-5.759 2.66-6.807a.51.51 0 01.63-.146c.07.034.132.084.179.146.834 1.048 2.66 3.7 2.66 6.807zM848.414 296.566a11.683 11.683 0 00-5.579 2.899 3.1 3.1 0 01-1.102 4.269 3.105 3.105 0 01-4.26-1.149 3.098 3.098 0 01.035-3.12 11.733 11.733 0 00-5.585-2.899.745.745 0 00-.891.891 10.462 10.462 0 008.485 8.48 1.337 1.337 0 011.302 0 10.451 10.451 0 008.485-8.48.737.737 0 00-.89-.891z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M848.414 303.841a11.681 11.681 0 00-5.579 2.898 3.1 3.1 0 01-2.664 4.691 3.103 3.103 0 01-3.102-3.135 3.105 3.105 0 01.439-1.556 11.732 11.732 0 00-5.585-2.898.74.74 0 00-.691.2.748.748 0 00-.2.69 10.458 10.458 0 002.906 5.576 10.476 10.476 0 005.579 2.905 1.37 1.37 0 011.302 0 10.446 10.446 0 008.485-8.481.74.74 0 00-.519-.879.74.74 0 00-.371-.011z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M848.414 311.116a11.681 11.681 0 00-5.579 2.898 3.1 3.1 0 01-2.664 4.691 3.103 3.103 0 01-3.102-3.135 3.105 3.105 0 01.439-1.556 11.732 11.732 0 00-5.585-2.898.74.74 0 00-.691.2.748.748 0 00-.2.69 10.45 10.45 0 008.485 8.481 1.37 1.37 0 011.302 0 10.43 10.43 0 008.485-8.481.74.74 0 00-.519-.879.74.74 0 00-.371-.011z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M848.414 318.39a11.683 11.683 0 00-5.579 2.899 3.095 3.095 0 01.034 3.12 3.095 3.095 0 01-2.698 1.571 3.103 3.103 0 01-3.102-3.136 3.1 3.1 0 01.439-1.555 11.733 11.733 0 00-5.585-2.899.752.752 0 00-.88.52.74.74 0 00-.011.371 10.439 10.439 0 002.903 5.579 10.456 10.456 0 005.582 2.902 1.37 1.37 0 011.302 0 10.436 10.436 0 005.585-2.899 10.415 10.415 0 002.9-5.582.74.74 0 00-.2-.69.748.748 0 00-.69-.201z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M848.414 325.665a11.71 11.71 0 00-5.579 2.905 3.102 3.102 0 01.026 3.11 3.093 3.093 0 01-4.245 1.143 3.096 3.096 0 01-1.54-2.702 3.082 3.082 0 01.432-1.551 11.76 11.76 0 00-5.585-2.905.752.752 0 00-.88.52.74.74 0 00-.011.371 10.446 10.446 0 008.485 8.481 1.371 1.371 0 011.302 0 10.436 10.436 0 005.585-2.899 10.415 10.415 0 002.9-5.582.74.74 0 00-.2-.691.756.756 0 00-.69-.2z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M848.414 332.94a11.702 11.702 0 00-5.579 2.905 3.102 3.102 0 01.026 3.109 3.089 3.089 0 01-2.69 1.563 3.1 3.1 0 01-2.69-1.563 3.092 3.092 0 01.027-3.109 11.752 11.752 0 00-5.585-2.905.74.74 0 00-.691.2.745.745 0 00-.2.69 10.45 10.45 0 008.485 8.481 1.37 1.37 0 011.302 0 10.43 10.43 0 008.485-8.481.736.736 0 00-.2-.69.748.748 0 00-.69-.2z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M848.413 340.215a11.702 11.702 0 00-5.579 2.905 3.092 3.092 0 01-2.663 4.672 3.103 3.103 0 01-2.69-1.563 3.1 3.1 0 01.026-3.109 11.734 11.734 0 00-5.585-2.905.752.752 0 00-.891.896 10.447 10.447 0 008.486 8.475 1.366 1.366 0 011.301 0 10.423 10.423 0 008.486-8.475.744.744 0 00-.891-.896z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M848.413 347.49a11.693 11.693 0 00-5.579 2.905 3.092 3.092 0 01-2.663 4.672 3.103 3.103 0 01-2.69-1.563 3.1 3.1 0 01.026-3.109 11.734 11.734 0 00-5.585-2.905.752.752 0 00-.891.896 10.447 10.447 0 008.486 8.475 1.366 1.366 0 011.301 0 10.423 10.423 0 008.486-8.475.746.746 0 00-.891-.896z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M840.168 433.978V296.541",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M843.232 291.628c0 3.107-1.826 5.765-2.66 6.814a.52.52 0 01-.404.198.515.515 0 01-.404-.198c-.834-1.049-2.66-3.707-2.66-6.814s1.826-5.759 2.66-6.814a.524.524 0 01.404-.194.525.525 0 01.404.194c.834 1.055 2.66 3.707 2.66 6.814z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M914.326 181.496a8.497 8.497 0 01-4.878 2.135.374.374 0 01-.313-.103.363.363 0 01-.104-.314 7.315 7.315 0 017.014-7.01.38.38 0 01.311.107.38.38 0 01.106.31 8.531 8.531 0 01-2.136 4.875z",
    fill: "#00B487",
    stroke: "#001E3C",
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M851.718 195.174a8.478 8.478 0 013.052 4.358.368.368 0 01-.043.327.369.369 0 01-.286.165 7.306 7.306 0 01-8.245-5.507.368.368 0 01.042-.327.382.382 0 01.286-.165 8.48 8.48 0 015.194 1.149z",
    fill: "#5AB45C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M944.528 248.062a8.504 8.504 0 012.142 4.875.352.352 0 01-.017.167.356.356 0 01-.089.143.356.356 0 01-.143.089.355.355 0 01-.168.017 8.465 8.465 0 01-4.877-2.134 8.552 8.552 0 01-2.142-4.875.383.383 0 01.019-.168.387.387 0 01.236-.232.382.382 0 01.168-.017 8.509 8.509 0 014.871 2.135z",
    fill: "#00B487",
    stroke: "#001E3C",
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M868.083 172.352a5.885 5.885 0 01.676 3.619.285.285 0 01-.041.108.257.257 0 01-.083.081.264.264 0 01-.224.025 5.051 5.051 0 01-2.949-2.203c-.671-1.079-.911-2.371-.671-3.619a.254.254 0 01.121-.192.267.267 0 01.226-.023 5.913 5.913 0 012.945 2.204zM896.528 204.64a5.837 5.837 0 013.159 1.851.235.235 0 01.059.101.253.253 0 01-.035.225.251.251 0 01-.087.078 5.055 5.055 0 01-6.748-1.08.26.26 0 01-.021-.32.26.26 0 01.084-.078 5.876 5.876 0 013.589-.777z",
    fill: "#458845",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M935.246 212.465a6.273 6.273 0 013.791-1.099.274.274 0 01.269.222.293.293 0 01-.003.125 5.424 5.424 0 01-5.851 4.465.28.28 0 01-.269-.223.278.278 0 01.004-.125 6.312 6.312 0 012.059-3.365z",
    fill: "#5AB45C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M898.524 185.077a5.16 5.16 0 100-10.319 5.16 5.16 0 100 10.319z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M809.765 399.891s16.604-17.114 33.487-9.517c14.286 6.435 4.568 24.527-3.065 20.675-7.12-3.593.582-15.503 10.11-9.908 9.528 5.595 14.69-.133 21.905 4.073 12.403 7.224-.341 19.494-5.25 16.065-3.722-2.608 0-6.056 3.235-2.419 4.846 5.456 6.76 14.594 15.518 6.202 3.077-2.949.632-11.525 9.477-13.312",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M813.543 389.534l3.31.417a2.743 2.743 0 003.065-2.374l.474-3.789a.893.893 0 00-.987-1 .896.896 0 00-.485.217c-1.068.947-1.011 2.027-2.047 1.048l-.279-.265c-1.775-.815-2.944.176-2.691 2.027l.221.404c.632 1.206-.367.815-1.46 1.617l-.088.063a1.2 1.2 0 00.967 1.635z",
    fill: "#458845",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M818.951 389.332c.038 0 .973 2.393 4.549.903",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M799.44 406.591c1.491-.36 4.272.549 5.737-2.009 2.218-3.871 1.656-8.499 4.145-11.19 1.397-1.509 3.058-.631 2.666.941-.391 1.573-3.127 9.233-1.2 10.572 1.927 1.338 4.897 1.427 6.072 1.894 1.175.467-.316 1.01-.682 1.263-.367.253-3.987-.53-4.644-.341s-.721.764-1.315.941a3.864 3.864 0 01-2.148-.417c-.486-.24-1.131.411-1.977.385-.847-.025-8.366.96-9.244.405-.714-.48 1.087-2.072 2.59-2.444z",
    fill: "#A9D063"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M799.44 406.591c1.491-.36 4.272.549 5.737-2.009 2.218-3.871 1.656-8.499 4.145-11.19 1.397-1.509 3.058-.631 2.666.941-.391 1.573-3.127 9.233-1.2 10.572 1.927 1.338 4.897 1.427 6.072 1.894 1.175.467-.316 1.01-.682 1.263-.367.253-3.987-.53-4.644-.341s-.721.764-1.315.941a3.864 3.864 0 01-2.148-.417c-.486-.24-1.131.411-1.977.385-.847-.025-8.366.96-9.244.405-.714-.48 1.087-2.072 2.59-2.444z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M825.425 434.973c6.685-1.51 10.608-9.352 8.763-17.517-1.846-8.164-8.761-13.559-15.446-12.05-6.685 1.51-10.608 9.352-8.763 17.516 1.846 8.165 8.761 13.56 15.446 12.051z",
    fill: "#458845"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M825.425 434.973c6.685-1.51 10.608-9.352 8.763-17.517-1.846-8.164-8.761-13.559-15.446-12.05-6.685 1.51-10.608 9.352-8.763 17.516 1.846 8.165 8.761 13.56 15.446 12.051z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M821.235 436.323c6.016-.743 10.059-8.08 9.031-16.387-1.028-8.307-6.737-14.438-12.753-13.695-6.015.744-10.059 8.081-9.031 16.388 1.028 8.307 6.738 14.438 12.753 13.694z",
    fill: "#458845"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M821.235 436.323c6.016-.743 10.059-8.08 9.031-16.387-1.028-8.307-6.737-14.438-12.753-13.695-6.015.744-10.059 8.081-9.031 16.388 1.028 8.307 6.738 14.438 12.753 13.694z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M816.301 436.688c5.726-.897 9.306-8.398 7.995-16.753-1.311-8.356-7.015-14.402-12.741-13.505-5.727.898-9.306 8.398-7.995 16.754 1.31 8.355 7.015 14.401 12.741 13.504z",
    fill: "#458845"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M816.301 436.688c5.726-.897 9.306-8.398 7.995-16.753-1.311-8.356-7.015-14.402-12.741-13.505-5.727.898-9.306 8.398-7.995 16.754 1.31 8.355 7.015 14.401 12.741 13.504z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M805.047 422.755c1.845-8.164-2.078-16.007-8.763-17.516-6.685-1.509-13.6 3.886-15.445 12.05-1.846 8.165 2.077 16.007 8.762 17.516 6.685 1.51 13.6-3.885 15.446-12.05z",
    fill: "#458845"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M805.047 422.755c1.845-8.164-2.078-16.007-8.763-17.516-6.685-1.509-13.6 3.886-15.445 12.05-1.846 8.165 2.077 16.007 8.762 17.516 6.685 1.51 13.6-3.885 15.446-12.05z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M806.51 422.444c1.028-8.307-3.015-15.644-9.03-16.387-6.016-.744-11.726 5.388-12.754 13.695-1.027 8.307 3.016 15.643 9.031 16.387 6.016.744 11.725-5.388 12.753-13.695z",
    fill: "#458845"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M806.51 422.444c1.028-8.307-3.015-15.644-9.03-16.387-6.016-.744-11.726 5.388-12.754 13.695-1.027 8.307 3.016 15.643 9.031 16.387 6.016.744 11.725-5.388 12.753-13.695z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M811.372 422.899c1.311-8.356-2.269-15.857-7.995-16.754-5.726-.897-11.431 5.149-12.741 13.505-1.311 8.355 2.269 15.856 7.995 16.753 5.726.897 11.43-5.149 12.741-13.504z",
    fill: "#458845"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M811.372 422.899c1.311-8.356-2.269-15.857-7.995-16.754-5.726-.897-11.431 5.149-12.741 13.505-1.311 8.355 2.269 15.856 7.995 16.753 5.726.897 11.43-5.149 12.741-13.504z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M807.136 438.67c5.503 0 9.964-7.489 9.964-16.728s-4.461-16.728-9.964-16.728-9.964 7.489-9.964 16.728 4.461 16.728 9.964 16.728z",
    fill: "#458845"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M807.136 438.67c5.503 0 9.964-7.489 9.964-16.728s-4.461-16.728-9.964-16.728-9.964 7.489-9.964 16.728 4.461 16.728 9.964 16.728z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M865.694 399.171l-2.912 1.623a2.744 2.744 0 01-3.734-1.055l-1.864-3.341a.885.885 0 01.106-.997.89.89 0 01.968-.266c1.339.474 1.693 1.497 2.287.209l.164-.354c1.334-1.414 2.793-.941 3.254.872 0 0 0 .183-.05.461-.146 1.351.632.631 1.958.947h.102a1.21 1.21 0 01-.279 1.901z",
    fill: "#458845",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M860.596 401.008c-.038 0 0 2.583-3.873 2.526",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M866.168 430.126l1.933-2.715a2.747 2.747 0 00.478-2.045 2.753 2.753 0 00-1.11-1.782l-3.114-2.223a.895.895 0 00-1.017-.013.895.895 0 00-.333.416.896.896 0 00-.034.532c.322 1.383 1.295 1.844-.051 2.292l-.373.12c-1.548 1.175-1.263 2.671.512 3.328h.468c1.358 0 .537.707.726 2.052v.101a1.215 1.215 0 00.973.441 1.215 1.215 0 00.942-.504z",
    fill: "#458845",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M868.557 425.264c0-.045 2.565.284 2.95-3.575M872.917 405.681a3.257 3.257 0 01-1.064-.716 3.278 3.278 0 01-.693-3.584 2.62 2.62 0 013.444-1.402 2.096 2.096 0 011.132 1.144 2.095 2.095 0 01-.008 1.609 1.686 1.686 0 01-2.205.897 1.328 1.328 0 01-.435-.294 1.33 1.33 0 01-.39-.953 1.34 1.34 0 01.105-.515M845.735 410.563a3.298 3.298 0 00-1.674 4.338 2.626 2.626 0 003.468 1.339 2.105 2.105 0 001.075-2.772 1.669 1.669 0 00-.931-.889 1.68 1.68 0 00-1.287.03 1.332 1.332 0 00-.712.744 1.348 1.348 0 00.023 1.03M890.728 413.569a3.292 3.292 0 014.606.631 2.634 2.634 0 01-.499 3.688 2.118 2.118 0 01-1.56.409 2.09 2.09 0 01-1.391-.813 1.672 1.672 0 01-.113-1.865c.111-.19.259-.357.435-.491a1.363 1.363 0 011.002-.263 1.366 1.366 0 01.894.522M845.994 391.902a3.283 3.283 0 01-1.997-4.193 2.628 2.628 0 013.355-1.598 2.106 2.106 0 011.264 2.684 1.685 1.685 0 01-2.149 1.023 1.365 1.365 0 01-.767-.688 1.347 1.347 0 01-.054-1.029",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "empty_2_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 273,
    y: 267,
    width: 321,
    height: 168
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M536.502 267a57.117 57.117 0 0152.758 35.233 57.04 57.04 0 014.347 21.841v110.144H307.5L273 324.074c0-15.137 212.413-29.654 223.122-40.357A57.118 57.118 0 01536.502 267z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#empty_2_svg__a)",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512.189 363.864l-8.062-15.067h-9.636s-2.362-3.739-3.929-5.949c-10.742-13.046-31.51-1.376-31.51-1.376l-1.308 14.101 9.989 18.862h25.274l19.182-10.571z",
    fill: "#88F4CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.639 345.709l-.398-.076a35.79 35.79 0 01-13.813 18.852 35.822 35.822 0 01-44.121-2.596 35.786 35.786 0 01-11.505-20.342h-4.751c-42.819 0-54.382 53.159-54.382 53.159l6.849 3.922h9.478l12.169 14.132h225.299l7.727-22.209s-77.88-34.448-132.552-44.842z",
    fill: "#F34C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.252 412.767a47.382 47.382 0 0022.473-21.425 47.335 47.335 0 004.373-30.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.165 408.34h-96.917v4.42h96.917v-4.42z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.982 434.433c19.193 0 34.751-15.55 34.751-34.732s-15.558-34.732-34.751-34.732c-19.192 0-34.751 15.55-34.751 34.732s15.559 34.732 34.751 34.732z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.229 352.005l2.685-4.724c30.037 7.168 64.276 19.658 87.705 28.872l.158 3.467a9.479 9.479 0 01-11.828 6.315l-72.421-22.102a9.474 9.474 0 01-6.299-11.828z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.785 434.433c16.575 0 30.012-13.429 30.012-29.996 0-16.566-13.437-29.995-30.012-29.995-16.576 0-30.013 13.429-30.013 29.995 0 16.567 13.437 29.996 30.013 29.996z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.785 421.803c9.596 0 17.375-7.775 17.375-17.366s-7.779-17.366-17.375-17.366c-9.597 0-17.376 7.775-17.376 17.366s7.779 17.366 17.376 17.366z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.809 341.547a35.811 35.811 0 008.955 17.853 35.843 35.843 0 0017.127 10.286 35.712 35.712 0 01-12.839-27.45c0-.253-4.651-16.419-4.644-16.653-8.637 0-3.665 15.952-8.599 15.964z",
    fill: "#FCBF4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.712 342.861a35.616 35.616 0 017.386 17.751 35.864 35.864 0 009.143-14.979c-6.609-1.257-11.847-2.141-16.529-2.772z",
    fill: "#6EC6DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.766 334.323c1.131 3.48-.404 4.844-.954 6.65-.196.631 1.112.985.588 1.402-2.401 1.894-7.841-1.945-13.692-1.358-2.628.265-7.203.991-9.244-.272-3.424-2.115-5.168-6.315-5.168-10.4 0-6.511 5.743-11.784 12.826-11.784 10.337 0 13.629 9.548 15.644 15.762z",
    fill: "#FCBF4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.731 334.039c1.611 0 4.707-.265 4.771-.821.044-.385-.993-3-1.928-5.052a21.298 21.298 0 00-1.327-2.564c-.183-.195-6.021 1.775-7.632 1.964-1.611.19-3.229-.246-4.353-.177-1.125.07-1.839 1.806-.828 2.583 1.011.777 2.028.79 2.685 1.131.657.341 1.182 2.38 2.041 2.658s4.96.278 6.571.278z",
    fill: "#6EC6DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.982 421.803c12.214 0 22.115-9.895 22.115-22.102 0-12.206-9.901-22.102-22.115-22.102-12.213 0-22.114 9.896-22.114 22.102 0 12.207 9.901 22.102 22.114 22.102z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.562 342.861a35.513 35.513 0 016.406 12.724M483.87 351.48a35.771 35.771 0 011.39 4.105h19.852M593.784 421.803v-34.732M581.501 416.72l24.572-24.559M576.409 404.437h34.751M581.501 392.161l24.572 24.559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.784 410.752a6.317 6.317 0 006.319-6.315 6.317 6.317 0 00-6.319-6.315 6.317 6.317 0 00-6.318 6.315 6.317 6.317 0 006.318 6.315z",
    fill: "#6EC6DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.982 421.803v-44.204M417.345 415.331l31.275-31.253M410.868 399.701h44.229M417.345 384.078l31.275 31.253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.982 406.016a6.317 6.317 0 006.319-6.315 6.317 6.317 0 00-6.319-6.315 6.317 6.317 0 00-6.318 6.315 6.317 6.317 0 006.318 6.315z",
    fill: "#6EC6DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.556 380.958h14.001v13.729h-14.001a6.318 6.318 0 01-6.319-6.315v-1.124a6.317 6.317 0 016.319-6.29z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.669 410.752h-54.648M371.808 394.169h-54.647M380.238 403.357h-15.733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.964 390.98a17.375 17.375 0 0128.376-2.392 17.35 17.35 0 013.993 10.178v.285a14.138 14.138 0 004.267 9.703 14.155 14.155 0 009.817 4.013h5.819a39.446 39.446 0 00-14.525-45.314 39.508 39.508 0 00-32.473-5.981 39.47 39.47 0 00-29.732 37.162h10.905a15.645 15.645 0 0013.553-7.654z",
    fill: "#F34C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.792 403.357h-18.804"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empty_2_svg__clip0_10367_214775"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h987v444H0z"
  })))));
}

export default SvgEmpty2;